var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-no-access"},[_vm._v("无访问权限，请联系系统管理员")])}
var staticRenderFns = []

export { render, staticRenderFns }